import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import {
  IAuthResponse,
  IPublicBusinessConfig,
} from '@g99-product-web-ui/shared-interface-lib';
import { SanitizeService } from '@g99-product-web-ui/shared-service';
import {
  G99ColoredLogo,
  NotificationIcon,
} from '@g99-product-web-ui/shared-util-lib';

import {
  IMenuItem,
  IProfileMenuItem,
} from '../../../interfaces/IMenu.interface';

@Component({
  selector: 'g99-lib-mobile-header',
  templateUrl: './mobile-header.component.html',
  styleUrl: './mobile-header.component.scss',
  standalone: false,
})
export class MobileHeaderComponent {
  @Input() public usersData!: IAuthResponse; // Object containing user-related details
  @Input() public businessData: IPublicBusinessConfig =
    {} as IPublicBusinessConfig; // Object containing business-related details
  @Input() public menuItems: IMenuItem[] = []; // Array of menu items for the navigation
  @Input() public profileMenus: IProfileMenuItem[] = [];
  @Input() public hasUnread = false;

  // optional: bubble click up to parent if needed
  @Output() public notificationsClick = new EventEmitter<void>();
  protected isDockVisible = false; // Controls the visibility of the dock
  protected notificationIcon!: SafeHtml;
  protected mobileLogo = G99ColoredLogo;

  constructor(private _sanitizer: SanitizeService) {
    this.notificationIcon = this._sanitizer.sanitizeContent(NotificationIcon);
  }
  // Toggles the dock's visibility
  protected toggleDock(): void {
    this.isDockVisible = !this.isDockVisible;
  }

  // Toggles the submenu visibility
  protected toggleSubmenu(menu: IMenuItem): void {
    menu.isActive = !menu.isActive;
  }
  protected onNotificationsClick(): void {
    this.notificationsClick.emit();
  }
}
